export default __webpack_public_path__ + "static/media/Management.cab96d5f.png";